import React from "react";

export default function CursosSummary({ resumen, onQuickFilter, activeKey }) {
  const cards = [
    { key: "total", label: "Cursos registrados", value: resumen?.total ?? 0, icon: "bi bi-mortarboard", accent: "total" },
    { key: "activos", label: "Activos", value: resumen?.activos ?? 0, icon: "bi bi-check2-circle", accent: "success" },
    { key: "inactivos", label: "Inactivos", value: resumen?.inactivos ?? 0, icon: "bi bi-slash-circle", accent: "muted" },
    { key: "nivel1", label: "Nivel 1", value: resumen?.nivel1 ?? 0, icon: "bi bi-ladder", accent: "info" },
    { key: "nivel2", label: "Nivel 2", value: resumen?.nivel2 ?? 0, icon: "bi bi-ladder", accent: "warning" },
  ];

  return (
    <div className="management-card mb-4">
      <div className="curso-summary-grid">
        {cards.map((card) => (
          <button
            key={card.key}
            type="button"
            className={`management-stat-card curso-card ${card.accent} ${activeKey === card.key ? "active" : ""}`}
            onClick={() => onQuickFilter?.(card.key)}
          >
            <div className="management-stat-icon">
              <i className={card.icon} />
            </div>
            <div>
              <p className="management-stat-label mb-1">{card.label}</p>
              <p className="management-stat-value mb-0">{card.value}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
